import { styled } from 'linaria/react';
import Button from './Button';
export const TrendButton = /*#__PURE__*/styled(Button)({
  name: "TrendButton",
  class: "t48m0a0",
  vars: {
    "t48m0a0-0": [({
      inverted
    }) => inverted ? '#fff' : '#000'],
    "t48m0a0-1": [({
      inverted
    }) => inverted ? '#000' : '#fff']
  }
});
export default TrendButton;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Button/TrendButton.linaria.css");